/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type CardDtoType = typeof CardDtoType[keyof typeof CardDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardDtoType = {
  CARD: 'CARD',
  OTHER: 'OTHER',
  VIRTUAL: 'VIRTUAL',
  FOB: 'FOB',
} as const;
